import React, { Component } from 'react';

const miscUtils = {
    copyToClipboard: (textToCopy, parentElement=document.body) => {
        if (navigator.clipboard && window.isSecureContext) {                
            return navigator.clipboard.writeText(textToCopy);
        } else {
            // text area method
            let textArea = document.createElement('textarea');
            textArea.value = textToCopy;
            textArea.innerText = textToCopy;
            
            // make the textarea out of viewport
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';

            parentElement.appendChild(textArea);
            textArea.select();

            return new Promise((res, rej) => {
                document.execCommand('copy') ? res() : rej({
                    statusCode: 500,
                    error: 'Error using document.execCommand to copy to clipboard'
                });
                parentElement.removeChild(textArea);
            });
        }
    },

    loadScript: (url, callback) => {
        let script = document.createElement('script')
        script.type = 'text/javascript';
    
        if (script.readyState) {  //IE
            script.onreadystatechange = function() {
                if (script.readyState == 'loaded' || script.readyState == 'complete') {
                    script.onreadystatechange = null;
                    callback();
                }
            };
        } else {  //Others
            script.onload = function() {
                callback();
            };
        }
    
        script.src = url;
        document.getElementsByTagName('head')[0].appendChild(script);
    },

    createExternalLink: (url, text=null) => {
        if (window._externalUrlsDisable) {
            return <span>{text ? text : url}</span>
        } else {
            return <a href={url} target='_blank'>{text ? text : url}</a>
        }
    },

    centeredPopupWindow: (url, windowName, win, w, h) => {
        const y = win.top.outerHeight / 2 + win.top.screenY - ( h / 2);
        const x = win.top.outerWidth / 2 + win.top.screenX - ( w / 2);
        return win.open(url, windowName, `width=${w}, height=${h}, top=${y}, left=${x}`);
    }
};

export default miscUtils;